import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  controllers: [],
  controllerToUpdate: {},
  loading: false,
  error: false,
};

const domainControllersSlice = createSlice({
  name: 'domainControllers',
  initialState,
  reducers: {
    domainControllersAdded(state, action) {
      state.controllers.push(action.payload);
    },
    getDomainControllers(state) {
      state.loading = true;
    },
    getDomainControllersSuccess(state, action) {
      state.loading = false;
      state.error = false;
      state.controllers = action.payload;
    },
    getDomainControllersFailure(state, action) {
      state.loading = false;
      state.error = true;
      state.controllers = action.payload;
    },
    deletedDomainController(state, action) {
      state.controllers = state.controllers.filter(
        (controller) => controller.id !== action.payload
      );
    },
    updatedController(state, action) {
      state.controllerToUpdate = action.payload;
    },
  },
});

export const {
  domainControllersAdded,
  getDomainControllers,
  getDomainControllersSuccess,
  getDomainControllersFailure,
  deletedDomainController,
  updatedController,
} = domainControllersSlice.actions;
export default domainControllersSlice.reducer;
